import create from 'zustand';

const useAuthStore = create((set) => ({
  loginData: null,
  setLoginData: (data) => set({ loginData: data }),
}));

export default useAuthStore;
